import { render, staticRenderFns } from "./ziliao.vue?vue&type=template&id=08e624ea&scoped=true&"
import script from "./ziliao.vue?vue&type=script&lang=ts&"
export * from "./ziliao.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e624ea",
  null
  
)

export default component.exports